import { useTranslation } from '@app/core/i18n';

export const useBankAccountsTranslation = () => useTranslation('bank-accounts');
